import { render, staticRenderFns } from "./marketingInvitation.vue?vue&type=template&id=4bef9aa9&scoped=true&"
import script from "./marketingInvitation.vue?vue&type=script&lang=js&"
export * from "./marketingInvitation.vue?vue&type=script&lang=js&"
import style0 from "./marketingInvitation.vue?vue&type=style&index=0&id=4bef9aa9&prod&scoped=true&lang=scss&"
import style1 from "./marketingInvitation.vue?vue&type=style&index=1&id=4bef9aa9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef9aa9",
  null
  
)

export default component.exports